
import React, { useState } from 'react';
import check from 'images/check.png';
import avatar1 from 'images/avatar-1.png';
import avatar2 from 'images/avatar-2.png';
import bookCover from 'images/book-cover24.png';
import ModalEmail from 'components/ModalEmail';

import * as S from './styles';

function SectionOne() {
  const [showModal, setShowModal] = useState(false);

  const openModal = () => {
    setShowModal(prev => !prev);
  }

  return (
    <S.Wrapper>
      <div className='title-header'>
        <div className='d-grid'>
          <div className='div-block-red' />
          <S.Content>
            <h2>
              <span>Affiliate Marketers:</span> <br />
              Did You Get The Largest Affiliate Report of 2024?
            </h2>
          </S.Content>
          <div />
        </div>
      </div>
      <section>
        <img src={bookCover} alt="" className="book-cover" />
        <article>

          <S.Content>

            <h1>
              What's Working in
              <br />
              Affiliate Marketing <span className='red'>2024</span>
            </h1>
            <ul className="list-content">
              <li>
                <img src={check} alt="" />
                <p>
                  How the Biggest Names in the Industry are Making Their Profits
                </p>
              </li>
              <li>
                <img src={check} alt="" />
                <p>
                  Secrets to Success: From Super-Affiliates to Ecom Experts
                </p>
              </li>
              <li>
                <img src={check} alt="" />
                <p>Gold Intel from Top Spy Tools</p>
              </li>
              <li>
                <img src={check} alt="" />
                <p>What's Working on Tiktok, Facebook, Native, Google, Push, Pop, and more</p>
              </li>
              <li>
                <img src={check} alt="" />
                <p>Best Advice for Newbies Starting Out in Year 2024</p>
              </li>
            </ul>
            <S.SubmitBtn data-id="bY16" onClick={openModal}>EMAIL ME THE FREE REPORT NOW</S.SubmitBtn>
            <ModalEmail showModal={showModal} setShowModal={setShowModal} />
            <ul className="info-links">
              @2024 AW x STM Forum.&nbsp;
              <li>
                <a href="https://affiliateworldforum.com/" target="blank">
                  <button>
                    About
                  </button>
                </a>
              </li>
              <li>
                <a href="https://affiliateworldforum.com/privacy.html" target="blank">
                  <button>
                    Privacy Policy
                  </button>
                </a>
              </li>
              <li>
                <a href=" https://affiliateworldforum.com/earnings-disclaimer.html" target="blank">
                  <button>
                    Earning Disclaimer
                  </button>
                </a>
              </li>
              <li>
                <a href="mailto:info@affiliateworldforum.com">
                  <button>
                    info@affiliateworldforum.com
                  </button>
                </a>
              </li>
            </ul>
          </S.Content>
        </article>
        <aside>
          <S.Testimonial>
            <div className="item">

              <p>
                "I'm absolutely certain we raised the bar with this year's
                report again. With 300+ pages of pure goodness from the
                brightest minds in affilaite marketing, it's the most
                compehensive report this industry has ever seen!"
              </p>
              <div className='author'>
                <img src={avatar1} alt="" />
                <small>
                  <strong>MATEJ CECHVALA (aka Matuloo)</strong>
                  <br /> Senior AW x STM Forum Moderator
                </small>
              </div>
            </div>
            <div className="item">

              <p>
                "The 'What's Working in 2024' report will help you eliminate guesswork, giving you the competitive advantage to stay ahead of the masses."
              </p>
              <div className='author'>
                <img src={avatar2} alt="" />
                <small>
                  <strong>SEBASTIAN ROESING (aka Twinaxe)</strong>
                  <br /> Senior AW x STM Forum Moderator
                </small>
              </div>
            </div>
          </S.Testimonial>
        </aside>
      </section>
      
    </S.Wrapper>
  );
}

export default SectionOne;
